import get from 'lodash/get';

const getPageName = () => {
  return {
    processing: {
      error_type: '',
      funnel_step: '',
      funnel_step_name: 'processing',
      page_category: 'offers',
      page_name: 'ib:offers:processing',
      page_type: 'other',
      page_url: '/offers/processing',
      product_category: '',
      product_subcategory: '',
      product_id: '',
    },
    landing: {
      error_type: '',
      funnel_step: '',
      funnel_step_name: '',
      page_category: 'offers',
      page_name: 'ib:offers',
      page_type: 'category',
      page_url: '/offers',
      product_category: '',
      product_subcategory: '',
      product_id: '',
    },
    errorPage: {
      error_type: '',
      funnel_step: '',
      funnel_step_name: '',
      page_category: 'offers',
      page_name: 'ib:offers:technical error',
      page_type: 'error',
      page_url: '/offers/technical-error',
      product_category: '',
      product_subcategory: '',
      product_id: '',
    },
  };
};

const getPageData = (currentPage) => {
  return {
    ...get(getPageName(), currentPage),
  };
};

export default getPageData;
